<template>
  <div class="task-overview" v-if="showVersionsMenu">
    <div class="to-versions">
      <button
        v-if="isUserSchoolAdmin && sortedVersions.length < 1 && savedStatements.length < 1"
        class="d-drop-box to-versions__save-bttn"
        type="button"
        @click="openSaveModal">
        {{ $t('vue2.task_versions.save_version') }}
      </button>
      <DDropdown v-else :isShowDots="false">
        <div class="d-drop-box" slot="title">{{ $t('vue2.task_versions.versions')}} <span class="icon-arrow-down52"></span></div>
        <ul slot="list">
          <template v-if="savedStatements.length">
            <li class="to-versions__heading">Opgørelser af ansættelse</li>
            <li v-for="statement in savedStatements" :key="'statement-' + statement.id"
                @click="activeStatement = statement">
              {{ statementTitle(statement) }}
            </li>
            <li v-if="sortedVersions.length" class="to-versions__heading to-versions__save--divider">
              {{ $t('vue2.task_versions.versions') }}
            </li>
          </template>
          <li v-for="version in sortedVersions" :key="version.id" @click="selectVersion(version)">
            {{ version.vTitle }}
          </li>
          <li
            v-if="isUserSchoolAdmin"
            class="to-versions__save"
            :class="{'to-versions__save--divider': sortedVersions.length > 0 || savedStatements.length > 0}"
            @click="openSaveModal">
            {{ $t('vue2.task_versions.save_new_version') }}
          </li>
        </ul>
      </DDropdown>
    </div>
    <DModal v-if="activeVersion" :showClose="false" :isBgOverlay="true" :appendToBody="true" :isPrintable="true" @close="activeVersion = null">
      <div class="to-versions__modal text-dark" slot="insertComponent">
        <div class="to-versions__modal__header no-print">
          <div class="to-versions__modal__header__left pad-1-left">
          <select v-model="activeVersionId" @change="selectVersionFromId(activeVersionId)">
            <option v-for="version in sortedVersions" :key="version.id" :value="version.id">
              {{ version.vTitle }}
            </option>
          </select>
            <span class="pad-1-left">
              {{ $t('vue2.task_versions.saved_message') }}: {{ versionDateFormatted }}
            </span>
          </div>
          <div class="to-versions__modal__header__right">
            <DDropdown :isBottomStart="false">
              <ul slot="list">
                <li @click="printVersion">
                  <span class="icon-printer3"></span> {{ $t('vue2.print_all_calendars.print') }}
                </li>
                <li v-if="isUserSchoolAdmin" class="d-item-warning" @click="setWarningToDelete">
                  <span class="icon-bin"></span> {{ $t('vue2.task_versions.delete_message') }}
                </li>
              </ul>
            </DDropdown>
            <div class="icon__bg-circle ww-modal__header__close" @click="activeVersion = null">
              <span class="icon-cross2"></span>
            </div>
          </div>
        </div>
        <div class="to-versions__modal__body" ref="versionBody">
          <TaskOverviewUser
            :user="user"
            :version="activeVersion">
          </TaskOverviewUser>
        </div>
      </div>
    </DModal>
    <DModal v-if="activeStatement" :appendToBody="true" :isBgOverlay="true" :showClose="false" @close="closeStatement">
      <div class="do-modal to-statement text-dark" slot="insertComponent">
        <div class="do-modal__header">
          <h2>{{ activeStatementTitle }}</h2>
          <div class="icon__bg-circle ww-modal__header__close" @click="closeStatement">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="do-modal__body to-statement__body">
          <AssignHoursWorkedHoursStatement
            :schoolId="schoolId"
            :users="[user]"
            :savedStatement="activeStatement"
            @title="activeStatementTitle = $event">
          </AssignHoursWorkedHoursStatement>
        </div>
      </div>
    </DModal>
    <DModal v-if="isDeleteWarningActive" :appendToBody="true" :isBgOverlay="true" :showClose="false" style="z-index: 999999999">
    <div class="brutto-warning text-dark" slot="insertComponent">
      <div class="brutto-warning__header">
        <h2>{{ $t('vue2.common.are_you_sure_you_want_to_delete') }}?</h2>
        <div class="icon__bg-circle doc-modal__close" @click="isDeleteWarningActive = false">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="brutto-warning__body">
        <svg class="tw-icon tw-icon--red" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        <h4>{{ $t('vue2.task_versions.confirm_delete_message') }} {{ activeVersion.vTitle }}?</h4>
        <p class="text-explainer">
          {{ $t('vue2.task_versions.delete_warning_message') }}
        </p>
      </div>
      <div class="brutto-warning__footer">
        <button @click="isDeleteWarningActive = false">{{ $t('vue2.common.cancel') }}</button>
        <button class="bttn bttn--warning bttn-danger bttn-primary--small" @click="deleteVersion" :class="[{'bttn--loading': isSaving}]">
          {{ $t('vue2.common.delete') }}
        </button>
      </div>
    </div>
  </DModal>
    <DModal v-if="isSaveModalActive" :appendToBody="true" :isBgOverlay="true" :showClose="false" @close="closeSaveModal">
      <div class="to-save-version text-dark" slot="insertComponent">
        <div class="to-save-version__header">
          <h2>{{ $t('vue2.task_versions.save_task_overview_version') }}</h2>
          <div class="icon__bg-circle doc-modal__close" @click="closeSaveModal">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="to-save-version__body">
          <h4 class="marg-05-bottom">{{ $t('vue2.task_versions.version_title') }}</h4>
          <input type="text" v-model="newVersionTitle" ref="version_name_input" @keyup.enter="saveVersion">
          <p class="text-desc">{{ $t('vue2.task_versions.auto_name_description') }}</p>
        </div>
        <div class="to-save-version__footer">
          <button @click="closeSaveModal">{{ $t('vue2.common.cancel') }}</button>
          <button class="bttn bttn-primary" :class="{'bttn--loading': isSaving}" @click="saveVersion">
            {{ $t('vue2.common.save') }}
          </button>
        </div>
      </div>
    </DModal>

  </div>
</template>

<script>
import eventbus from '../../../eventbus'
import docendo from '../../../docendo'
import Loader from '../../common/Loader'
import TaskOverviewUser from './TaskOverviewUser'
import DModal from '../../common/DModal'
import DDropdown from '../../common/DDropdown'
import AssignHoursWorkedHoursStatement from '../../AssignHours/AssignHoursWorkedHoursStatement.vue'
import moment from 'moment'

export default {
  components: {DDropdown, DModal, Loader, TaskOverviewUser, AssignHoursWorkedHoursStatement},
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      isLoading: false,
      versions: [],
      activeVersion: null,
      activeVersionId: null,
      isDeleteWarningActive: false,
      isDeleting: false,
      isSaveModalActive: false,
      newVersionTitle: '',
      statements: [],
      activeStatement: null,
      activeStatementTitle: ''
    }
  },
  computed: {
    userId () {
      return this.user ? this.user.id : null
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolYearId () {
      return this.$store.getters.schoolYearId
    },
    versionDateFormatted () {
      const date = this.activeVersion ? this.activeVersion.created_at : moment()
      return moment(date).format('LLL')
    },
    sortedVersions () {
      return this.versions.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at)
      }).filter(version => version.id).map(version => {
        return {
          ...version,
          vTitle: version.title ? version.title : moment(version.created_at).format('LLL')
        }
      })
    },
    theUser () {
      return this.$store.state.user
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    isUserSchoolAdmin () {
      return this.userHasPermission('can_manage_school')
    },
    showVersionsMenu () {
      return this.sortedVersions.length > 0 || this.savedStatements.length > 0 || this.isUserSchoolAdmin
    },
    canSeeStatements () {
      const country = String(this.$store.getters.schoolCountry).toLowerCase()
      return this.$store.getters.isSchoolSystem && country === 'dk' && this.isUserSchoolAdmin
    },
    savedStatements () {
      return this.statements
        .filter(statement => statement.closed_at && statement.school_year_id === this.schoolYearId)
        .sort((a, b) => a.from_date < b.from_date ? 1 : a.from_date > b.from_date ? -1 : b.id - a.id)
    }
  },
  watch: {
    schoolId () {
      this.readVersions()
      this.readStatements()
    },
    schoolYearId () {
      this.readVersions()
    },
    user () {
      this.readVersions()
      this.readStatements()
    },
    canSeeStatements () {
      this.readStatements()
    }
  },
  methods: {
    userHasPermission (permission) {
      if (!this.theUser) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin
      } else {
        return true
      }
    },
    readVersions () {
      if (!this.schoolYearId || !this.schoolId || !this.userId) {
        return
      }
      this.isLoading = true
      docendo.readTaskOverviews(this.schoolId, this.schoolYearId, this.userId, success => {
        this.isLoading = false
        if (success.status === 'error') {
          eventbus.toast = {text: success.message, success: false}
          return
        }
        this.versions = success
      }, failure => {
        this.isLoading = false
        eventbus.toast = {text: 'Something went wrong', success: false}
      })
    },
    readStatements () {
      if (!this.canSeeStatements || !this.schoolId || !this.userId) {
        this.statements = []
        return
      }
      const userId = this.userId
      docendo.listWorkedHoursStatements(this.schoolId, userId, data => {
        if (this.userId === userId && Array.isArray(data)) {
          this.statements = data
        }
      }, () => {})
    },
    statementTitle (statement) {
      return 'Opgørelse ' + moment(statement.from_date).format('D. MMM YYYY') + ' - ' +
        moment(statement.to_date).format('D. MMM YYYY')
    },
    closeStatement () {
      this.activeStatement = null
      this.readStatements()
    },
    selectVersion (version) {
      this.activeVersion = version
      if (version) {
        this.activeVersionId = version.id
      } else {
        this.activeVersionId = null
      }
    },
    selectVersionFromId (id) {
      const idx = this.sortedVersions.findIndex(version => version.id === id)
      this.selectVersion(this.sortedVersions[idx])
    },
    printVersion () {
      const source = this.$refs.versionBody ? this.$refs.versionBody.querySelector('.to-user') : null
      if (!source) {
        return
      }
      const title = this.$t('vue2.task_versions.task_overview')
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')]) {
        stylesHtml += node.outerHTML
      }
      const printStyles = `<style>
        html, body { background: #fff; margin: 0; }
        .to-user { page-break-after: auto !important; break-after: auto !important; }
        .only-print { display: flex !important; }
        .no-print { display: none !important; }
      </style>`
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html><html id="html-bg-white"><head><title>${title}</title>${stylesHtml}${printStyles}</head><body><div id="printTaskOverviews">${source.outerHTML}</div></body></html>`)
      WinPrint.onafterprint = () => {
        WinPrint.close()
      }
      setTimeout(_ => {
        WinPrint.document.close()
        WinPrint.focus()
        WinPrint.print()
      }, 1000)
    },
    setWarningToDelete () {
      this.isDeleteWarningActive = true
    },
    openSaveModal () {
      this.isSaveModalActive = true
      this.$nextTick(() => {
        if (this.$refs.version_name_input) {
          this.$refs.version_name_input.focus()
        }
      })
    },
    closeSaveModal () {
      if (this.isSaving) {
        return
      }
      this.isSaveModalActive = false
      this.newVersionTitle = ''
    },
    deleteVersion () {
      this.isDeleting = true
      docendo.deleteTaskOverview(this.schoolId, this.schoolYearId, this.userId, this.activeVersion.id, success => {
        this.isDeleteWarningActive = false
        this.isDeleting = false
        if (success.status === 'error') {
          eventbus.toast = {text: success.message, success: false}
          return
        }
        eventbus.toast = {text: 'Deleted', success: true}
        const idx = this.versions.findIndex(version => version.id === success.id)
        this.versions.splice(idx, 1)
        this.activeVersion = null
      }, failure => {
        eventbus.toast = {text: 'Something went wrong', success: false}
      })
    },
    saveVersion () {
      if (this.isSaving) {
        return
      }
      this.isSaving = true
      docendo.saveTaskOverview(this.schoolId, this.schoolYearId, this.userId, this.newVersionTitle, success => {
        this.isSaving = false
        if (success.status === 'error') {
          eventbus.toast = {text: success.message, success: false}
          return
        }
        this.newVersionTitle = ''
        this.isSaveModalActive = false
        eventbus.toast = {text: this.$t('vue2.common.saved'), success: true}
        this.versions.push(success)
        this.$nextTick(() => {
          const saved = this.sortedVersions.find(version => version.id === success.id)
          this.selectVersion(saved || success)
        })
      }, failure => {
        this.isSaving = false
        eventbus.toast = {text: this.$t('vue2.common.something_went_wrong'), success: false}
      })
    }
  },
  mounted () {
    this.readVersions()
    this.readStatements()
  }
}
</script>

<style scoped>
.to-versions__version {
  display: flex;
  align-items: center;
}

.to-versions__modal__body {
  border-radius: 4px;
}

.to-versions__modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px 4px 0 0;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  height: 50px;
}

.to-versions__modal__body {
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  width: 100vw;
  max-width: 800px;
  overscroll-behavior: contain;
}

@media print {
  .to-versions__modal__body {
    max-height: none;
    overflow: visible;
    width: 100%;
    max-width: none;
  }
}

.pad-1-left {
  padding-left: 1rem;
}

.to-versions__modal__header__left,
.to-versions__modal__header__right {
  display: flex;
  align-items: center;
}

.icon__bg-circle.ww-modal__header__close {
  margin-right: 1rem;
}

.to-versions__save-bttn {
  cursor: pointer;
  font-family: inherit;
  color: inherit;
}

.to-versions__save-bttn:hover {
  background-color: aliceblue;
}

.to-versions__save {
  font-weight: 600;
  color: #3d5afe;
}

.to-versions__heading {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #a2a3a6;
  cursor: default;
  pointer-events: none;
}

.to-statement {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: #ffffff;
}

.to-statement .do-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.to-statement__body {
  flex: 1;
  max-height: none;
  overflow-y: auto;
  padding: 1rem 2rem;
}

.to-versions__save--divider {
  margin-top: 0.25rem;
  border-top: 1px solid #eee;
}

.to-save-version {
  width: 420px;
  max-width: calc(100vw - 2rem);
  border-radius: 4px;
  background: #ffffff;
}

.to-save-version__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #dddddd;
}

.to-save-version__body {
  padding: 1rem;
}

.to-save-version__body input {
  width: 100%;
}

.to-save-version__footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  gap: 1rem;
}

.text-desc {
  font-size: 12px;
  color: #a2a3a6;
  font-weight: normal;
  font-style: italic;
  margin-top: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// TaskOverview.vue?5a40e8ee